import { h } from 'preact';
import clsx from 'clsx';
import { formatMoney } from '../../../utils/helpers';
import ThreekitIcons from '../threekit-icons';
import { useThreekit } from '../../threekit-context';
import { useModal } from '../../modal-context';
import { Swiper, SwiperSlide } from '../swiper';

function CompareMaterialsModal({ materials }) {
  const { darkMode } = useThreekit();
  const { closeModal, modalName } = useModal();

  if (modalName !== 'Compare Materials') {
    return null;
  }

  return (
    <div className="relative flex flex-col w-full gap-3 px-5 mt-3">
      <p
        className={clsx(
          'text-left laptop:text-center heading-6 laptop:heading-7',
          {
            'text-white': darkMode,
            'text-black': !darkMode,
          },
        )}
      >
        Compare Materials
      </p>
      <Swiper
        className="w-full h-[300px] laptop:max-h-[100px]"
        spaceBetween={10}
        slidesPerView={3}
        direction="vertical"
        allowTouchMove={true}
        breakpoints={{
          1024: {
            direction: 'horizontal',
            spaceBetween: 15,
            allowTouchMove: false,
          },
        }}
      >
        {Object.entries(materials).map(([material, products]) => {
          const description = products.find((product) => {
            const hasDescription = product.description && product.description.length > 0;
            const hasLeftHandle = product.handle && product.handle.includes('left');
            return hasDescription && hasLeftHandle;
          })?.description
            || products.find((p) => p.description && p.description.length > 0)
              ?.description;

          const getPrice = () => {
            // get enabled variants in the product
            const enabledVariants = products[0].variants.edges.filter(
              (variant) => variant.node.configurationEnabled,
            );
            const prices = enabledVariants.map(
              (variant) => variant.node.priceV2.amount,
            );
            const uniquePrices = [...new Set(prices)].sort();
            if (uniquePrices.length > 1) {
              return `${formatMoney({
                amount: uniquePrices[0],
              })} - ${formatMoney({
                amount: uniquePrices[uniquePrices.length - 1],
              })}`;
            }
            return formatMoney({ amount: uniquePrices[0] });
          };

          const textColor = darkMode ? 'text-white' : 'text-black';

          return (
            <SwiperSlide
              className="p-4 bg-black rounded-sm bg-opacity-20"
              key={`${material}-button`}
            >
              <div className={`font-m-12 uppercase ${textColor}`}>
                <span>{material}</span>
                <span className="ml-1 text-accent-1">{getPrice()}</span>
              </div>
              <p className={`mt-1 font-r-12 ${textColor}`}>{description}</p>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <button
        onClick={() => closeModal()}
        type="button"
        className="absolute top-0 right-[15px] laptop:right-[18px]"
      >
        <ThreekitIcons type="exitIcon" />
      </button>
    </div>
  );
}

export default CompareMaterialsModal;
